<template>
  <div>
    <div class="qrcontain" v-show="qrshow">
        <img class="close" src="@/assets/product/close.png" @click="closeQr"/>
        <div id="qrcode"  v-click-out="closeQr">
            <span class="title">{{title}}</span>
            <a class="url" :href="url" target="_blank">下载地址</a>
        </div>
    </div>
      <top-bar></top-bar>
      <div class="contain">
        <div class="first" id="jumppaint">
            <div class="left">
                <img src="@/assets/product/paintnum.png" class="main-img">
            </div>
            <div class="right">
                <div>
                    <img :src="getImg([paintnumword, paintnumwordTw, paintnumwordEn])">
                    <img src="@/assets/product/awards2019.png" class="awards">
                </div>
                <div class="item-tip">
                    {{getLan('c1b03a62-f0e1-42f8-8400-8225f5ea3256')}}
                </div>
                <div class="main-honor">
                    <img src="@/assets/product/peruser.png"/>
                    <span>{{getLan('60644350-cd69-410a-9f9b-057a7aac2838')}}</span>
                    <div></div>
                    <img src="@/assets/product/alluser.png"/>
                    <span>{{getLan('58a90a75-9328-4ad4-838c-73ea176571c4')}}</span>
                </div>
                <div class="descrip">
                    {{getLan('c5f8cf08-f821-415b-9360-39887106ebf5')}}
                    <br>
                    {{getLan('49463059-1a96-4711-a206-383a5628bd2f')}}
                    <br>
                    {{getLan('d2d12de5-6295-4b20-bd80-79e559cd2ec4')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'paint', 0)"/>
                        <img src="@/assets/product/appstore.png" @click="getQR($event, 'paint', 1)"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="second" id="jumppeace">
            <div class="right">
                <div>
                    <img src="@/assets/product/peaceword.png"/>
                </div>
                <div class="item-tip">
                    {{getLan('0df0b92e-6871-410a-93d1-e4d864617b35')}}
                </div>
                <div class="descrip">
                    {{getLan('76f3f77b-c12d-4048-93c2-a30c4ae25a77')}}<br>
                    {{getLan('f04d7eea-3920-43a2-a18a-a835fb3e7122')}}<br>
                    {{getLan('531dc042-8934-4914-8139-256ba5d715e6')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png"  @click="getQR($event, 'peace', 0)"/>
                        <img src="@/assets/product/appstore.png"  @click="getQR($event, 'peace', 1)"/>
                    </div>
                </div>
            </div>
            <div class="left">
                <img class="main-img" :src="getImg([peace, peace, peaceEn])"/>
            </div>
        </div>
        <div class="first">
            <div class="left">
                <img class="main-img" src="@/assets/game/sudoku.png"/>
            </div>
            <div class="right">
                <div>
                    <img :src="getImg([sudokuLogo, sudokuLogoTw, sudokuLogoEn])"/>
                </div>
                <div class="item-tip">
                    {{getLan('f50329a3-bc29-40d4-a3be-dde6efe370c0')}}
                </div>
                <div class="main-honor">
                    <img src="@/assets/product/peruser.png"/>
                    <span>{{getLan('80150672-76bb-4c2b-924e-e02f12fc97af')}}</span>
                    <img src="@/assets/product/alluser.png"/>
                    <span>{{getLan('ba875b22-fad1-4d8a-835c-6f2699d13662')}}</span>
                </div>
                <div class="descrip">
                    {{getLan('e7a1d071-0985-4ab1-820b-f893e6140a68')}}
                    <br>
                    {{getLan('2a55fced-20d1-4d84-b487-12840d6e90b0')}}
                    <br>
                    {{getLan('f778e33d-78f1-4856-a9d2-82aa58dbcbb0')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'sudoku', 0)"/>
                        <img src="@/assets/product/appstore.png" @click="getQR($event, 'sudoku', 1)"/>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="first">
            <div class="left">
                <img src="@/assets/product/秘密花园图.png" class="main-img">
            </div>
            <div class="right">
                <div>
                    <img :src="getImg([秘密花园, 秘密花园Tw, 秘密花园En])">
                </div>
                <div class="item-tip">
                    {{getLan('03dc95b1-80d9-4dc6-9044-45ac2ce219f9')}}
                </div>
                <div class="descrip">
                    {{getLan('4c8c91e4-9b4d-4224-b314-16a15c3c3b75')}}
                    <br>
                    {{getLan('6c5b3501-5a94-45e6-8c74-ea4941da1f95')}}
                    <br>
                    {{getLan('392d7adf-002a-4782-aebe-7de4c25c137d')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'color', 0)"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="second">
            <div class="right">
                <div>
                    <img src="@/assets/product/awards2018.png" class="awards">
                    <img :src="getImg([简笔画, 简笔画Tw, 简笔画En])"/>
                </div>
                <div class="item-tip">
                    {{getLan('31652926-5e2e-41b0-bcf4-47ebd3a55f7e')}}
                </div>
                <div class="main-honor">
                    <img src="@/assets/product/alluser.png"/>
                    <span>{{getLan('36eb8cad-689c-462b-90f8-3ec19f9c8093')}}</span>
                </div>
                <div class="descrip">
                    {{getLan('84123f25-1e28-4c01-aed0-c1919f484be8')}}
                    <br>
                    {{getLan('79ef28f1-bedd-4365-9c4a-62e9b64fb887')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'drawing', 0)"/>
                    </div>
                </div>
            </div>
            <div class="left">
                <img class="main-img" src="@/assets/product/简笔画图.png"/>
            </div>
        </div>
        <div class="first">
            <div class="left">
                <img src="@/assets/product/架子鼓图.png" class="main-img">
            </div>
            <div class="right">
                <div>
                    <img :src="getImg([架子鼓, 架子鼓Tw, 架子鼓En])">
                     <img src="@/assets/product/awards2018.png" class="awards">
                </div>
                <div class="item-tip">
                    {{getLan('c5d318f0-a2c6-45c9-afef-56fa5d2d3146')}}
                </div>
                <div class="main-honor">
                    <img src="@/assets/product/alluser.png"/>
                    <span>{{getLan('585c0d78-f7de-4933-be4e-554bbb43ae29')}}</span>
                </div>
                <div class="descrip">
                    {{getLan('a70d0f69-6b2c-4fb2-bd46-b83461ab1432')}}
                    <br>
                    {{getLan('35e98ad1-a135-4f15-86c0-42d77bd6e06c')}}
                    <br>
                    {{getLan('06d1ef71-bacc-4e5b-8648-e20f6bbe403f')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'rock', 0)"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="second">
            <div class="right">
                <div>
                    <img :src="getImg([电子鼓, 电子鼓Tw, 电子鼓En])"/>
                </div>
                <div class="item-tip">
                    {{getLan('b2306eb7-4307-46c7-8b7a-14435aa3bcbc')}}
                </div>
                <div class="main-honor">
                    <img src="@/assets/product/alluser.png"/>
                    <span>{{getLan('97485ec9-d7a7-46c9-a635-b63befe78940')}}</span>
                </div>
                <div class="descrip">
                    {{getLan('3487a68e-e4fb-4f9e-887c-f317a48ff354')}}
                    <br>
                    {{getLan('c543bcf1-f751-4cf1-9bcc-8ff7a6a0bdb7')}}
                    <br>
                    {{getLan('fce9b864-ca20-42e2-ba01-62f196ccfb94')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'drum', 0)"/>
                    </div>
                </div>
            </div>
            <div class="left">
                <img class="main-img" src="@/assets/product/电子鼓图.png"/>
            </div>
        </div>
        <div class="first">
            <div class="left">
                <img src="@/assets/product/圣经图.png" class="main-img"> 
            </div>
            <div class="right">
                <div>
                    <img :src="getImg([圣经, 圣经Tw, 圣经En])">
                </div>
                <div class="item-tip">
                    {{getLan('051f6c9f-77c9-40d7-a85e-b393d9874ad6')}}
                </div>
                <div class="main-honor">
                    <img src="@/assets/product/peruser.png"/>
                    <span>{{getLan('7e82fa25-c8b8-4f79-aa32-5c607b76271f')}}</span>
                </div>
                <div class="descrip">
                    {{getLan('1b1a0db8-94e7-4c4d-94bb-29d457c958bf')}}
                    <br>
                    {{getLan('5a99dc51-80df-4bb4-aa9e-6addadf6c1cf')}}
                    <br>
                    {{getLan('8af06465-8018-4e17-b3da-3de53be0eb2f')}}
                    <br>
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'bible', 0)"/>
                        <img src="@/assets/product/appstore.png" @click="getQR($event, 'bible', 1)"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="second">
            <div class="right">
                <div>
                    <img :src="getImg([吉他大师, 吉他大师Tw, 吉他大师En])"/>
                </div>
                <div class="item-tip">
                    {{getLan('3a3cdbf2-9247-47ea-9be6-28f6a6a213e8')}}
                </div>
                <div class="main-honor">
                    <img src="@/assets/product/alluser.png"/>
                    <span>{{getLan('da92d1bc-252a-49de-a10d-00860348bbab')}}</span>
                </div>
                <div class="descrip">
                    {{getLan('4b8c1096-1b8b-436b-8e70-bfb82b631d89')}}
                    <br>
                    {{getLan('a2e3fb23-d893-43ce-b8e6-6a333b8f96cc')}}
                    <br>
                    {{getLan('0602ccb5-d34f-46ce-a80f-367f17925bfa')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'guitar', 0)"/>
                    </div>
                </div>
            </div>
            <div class="left">
                <img class="main-img" src="@/assets/product/吉他大师图.png"/>
            </div>
        </div> -->
      </div>
      <bottom-bar></bottom-bar>
  </div>
</template>

<script>
import TopBar from './TopBar'
import BottomBar from './BottomBar'
import QRCode from 'qrcodejs2'
import paintnumword from '@/assets/product/paintnumword.png'
import paintnumwordEn from '@/assets/product/paintnumwordEn.png'
import paintnumwordTw from '@/assets/product/paintnumwordTw.png'
import 经典数独 from '@/assets/product/经典数独.png'
import 经典数独En from '@/assets/product/经典数独En.png'
import 经典数独Tw from '@/assets/product/经典数独Tw.png'
import 简笔画 from '@/assets/product/简笔画.png'
import 简笔画En from '@/assets/product/简笔画En.png'
import 简笔画Tw from '@/assets/product/简笔画Tw.png'
import 秘密花园 from '@/assets/product/秘密花园.png'
import 秘密花园En from '@/assets/product/秘密花园En.png'
import 秘密花园Tw from '@/assets/product/秘密花园Tw.png'
import 电子鼓 from '@/assets/product/电子鼓.png'
import 电子鼓En from '@/assets/product/电子鼓En.png'
import 电子鼓Tw from '@/assets/product/电子鼓Tw.png'
import 架子鼓 from '@/assets/product/架子鼓.png'
import 架子鼓En from '@/assets/product/架子鼓En.png'
import 架子鼓Tw from '@/assets/product/架子鼓Tw.png'
import 吉他大师 from '@/assets/product/吉他大师.png'
import 吉他大师En from '@/assets/product/吉他大师En.png'
import 吉他大师Tw from '@/assets/product/吉他大师Tw.png'
import  圣经 from '@/assets/product/圣经.png'
import  圣经En from '@/assets/product/圣经En.png'
import  圣经Tw from '@/assets/product/圣经Tw.png'
import peace from '@/assets/product/peace.png'
import peaceEn from '@/assets/product/peaceEn.png'
import sudokuLogo from '@/assets/game/sudokuLogo.png'
import sudokuLogoEn from '@/assets/game/sudokuLogoEn.png'
import sudokuLogoTw from '@/assets/game/sudokuLogoTw.png'
const urlInfo = {
    paint: ['https://play.google.com/store/apps/details?id=paint.by.number.pixel.art.coloring.drawing.puzzle', 'https://apps.apple.com/app/id1420058690'],
    peace: ['https://play.google.com/store/apps/details?id=peace.meditation.mindfulness.sleep.anxiety.free', 'https://apps.apple.com/app/id1390959004'],
    puzzle: ['https://play.google.com/store/apps/details?id=easy.sudoku.puzzle.solver.free'],
    drawing: ['https://play.google.com/store/apps/details?id=drawing.lessons.sketch.how.to.draw.portrait'],
    color: ['https://play.google.com/store/apps/details?id=adult.coloring.book.mandala.colorfy.coloring.free'],
    drum: ['https://play.google.com/store/apps/details?id=easy.drum.pad.electro.kit.beat.machine.maker'],
    rock: ['https://play.google.com/store/apps/details?id=easy.drum.set.free.finger.drums.kit'],
    guitar: ['https://play.google.com/store/apps/details?id=real.guitar.learn.chords.tuner.play.songs.tiles.pocket.rhythm.game'],
    bible: ['https://play.google.com/store/apps/details?id=bibleverses.bibleverse.bible.biblia.verse.devotion', 'https://apps.apple.com/app/id1252467466']
}

let lockHideQr = false
export default {
    components: {
        TopBar,
        BottomBar
    },
    data() {
        return {
            qrcode: null,
            qrshow: false,
            title: '',
            url: '',
            经典数独,
            经典数独Tw,
            简笔画En,
            paintnumwordEn,
            paintnumword,
            经典数独En,
            简笔画,
            秘密花园,
            秘密花园En,
            电子鼓,
            电子鼓En,
            架子鼓,
            架子鼓En,
            吉他大师,
            吉他大师En,
            圣经,
            圣经En,
            paintnumwordTw,
            简笔画Tw,
            电子鼓Tw,
            秘密花园Tw,
            架子鼓Tw,
            吉他大师Tw,
            圣经Tw,
            peace,
            peaceEn,
            sudokuLogo,
            sudokuLogoEn,
            sudokuLogoTw
        }
    },
    methods: {
        genQr(url) {
            this.url = url
            if (this.qrcode) {
                this.qrcode.clear()
                this.qrcode.makeCode(url)
                return
            }
            this.qrcode = new QRCode('qrcode', {
                width: 256,
                heigth: 256,
                text: url,
                // colorDark : "#000000",
                // colorLight : "#ffffff",
            })
        },
        moveQr(target) {
            let qrelement = document.querySelector('#qrcode')
            let qcotain = document.querySelector('.qrcontain')
            qcotain.style.top = window.scrollY + 'px'

        },
        getQR(e, type, index) {
            console.log(e)
            console.dir(e.target.offsetLeft)
            this.qrshow = true
            this.moveQr(e.target)
            this.genQr(urlInfo[type][index])
            lockHideQr = true
            this.title = index ? 'iOS' : 'Android'
            setTimeout(() => {
                lockHideQr = false
            }, 1000);
        },
        closeQr() {
            console.log('sfs')
            if (lockHideQr) return
            this.qrshow = false
        }
    },
}
</script>

<style scoped>
.qrcontain {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0,0,0,0.7);
    z-index: 888;
}
.close {
    width: 3.19rem;
    height: 3.19rem;
    position: absolute;
    top: 8.74rem;
    right: 3.72rem;
    cursor: pointer;
}
#qrcode {
    position: absolute;
    z-index: 1000;
    left: 50%;
    top: 50%;
    height: 330px;
    width: 256px;
    padding: 0.3rem;
    transform: translate(-50%, -50%);
    background: rgba(255, 255, 255, 1);
    padding: 0 2.41rem 2.41rem 2.41rem;
}
#qrcode .title {
    font-weight: 500;
    margin-left: 3.55rem;
    text-align: center;
    font-size: 14px;
    height: 2.41rem;
}
#qrcode .url {
    font-size: 14px;
    color: #FD9A27;
    text-decoration: none;
}
.contain {
    position: relative;
    padding-top: 5.97rem;
    /* padding-left: 23.98rem; */
    text-align: center;
    background: linear-gradient(#f7f9fb, #ffffff)
}
.title {
    font-size: 2.09rem;
    font-weight: bold;
    line-height: 3.8rem;
    color: #303030;
}
.first {
    display:flex;
    margin-top: 3.56rem;
    margin-bottom: 6rem;
}
.second {
    display:flex;
    margin-bottom: 6rem;
}

.first .left{
    text-align: right;
    margin-right: 4.29rem;
}
.second .left {
    text-align: left;
}
.second .right {
    min-width: 21rem;
    text-align: right;
    margin-right: 4.29rem;
}
.first .right div:first-child img{
    height: 3.77rem;
    text-align: left;
}
.first .right div:first-child img:first-child {
    height: 2.77rem;
}
.second .right div:first-child img{
    height: 2.77rem;
    text-align: right;
}

.left {
    width: 50%;
    /* display: inline-block; */
    /* margin-right: 4.29rem; */
    min-width: 21rem;
}
.right {
    width: 50%;
    /* display: inline-block;
    margin-left: 4.29rem;
    margin-right: 4.29rem; */
    /* vertical-align: top; */
    /* line-height: 26.49rem; */
    vertical-align: top;
    height: 26.49rem;
    padding-top: 2.5rem;
    text-align: left;
}
.main-img {
    width: 24.45rem;
    height: 26.49rem;
}
.item-tip {
    font-size: 1.68rem;
    font-weight: 500;
    color: #666;
    line-height: 2.23rem;
    margin-top: 0.99rem;
    margin-bottom: 1.26rem;
}
.main-honor img {
    height: 1.15rem;
}
.main-honor span{
    vertical-align: top;
    font-size: 0.94rem;
    /* line-height: 1.73rem; */
}
.main-honor div {
    display: inline-block;
    margin-left: 1.41rem;
}
.descrip {
    margin-top: 1.57rem;
    font-size: 0.94rem;
    color: #999999;
    line-height: 1.73rem;
}

.sign {
    margin-top: 2.04rem;
}
.sign img {
    position: relative;
    z-index: 700;
    cursor: pointer;
    height: 1.57rem;
}
.awards {
    vertical-align: bottom;
    height: 3.77rem !important;
}
</style>


// WEBPACK FOOTER //
// src/components/AllProduct.vue